<template>
  <div>
    <div class="mb-2">
      <p class="mb-1"><label class="form-label">Forma de entrega *</label></p>
      <div class="flex flex-col md:flex-row mb-2">
        <div
          class="w-full md:w-1/2 p-2 border text-center cursor-pointer"
          :class="dispatchType == 'SHIPPING' ? 'border-main text-main' : 'text-gray-500 hover:border-main hover:text-main'"
          @click="dispatchType = 'SHIPPING'">
          <action-icons icon="shipping" class="mx-auto mb-2 w-12 h-12" />
          <p>Despacho a domicilio</p>
        </div>
        <div
          class="w-full md:w-1/2 p-2 border text-center cursor-pointer"
          :class="dispatchType == 'PICKUP' ? 'border-main text-main' : 'text-gray-500 hover:border-main hover:text-main'"
          @click="dispatchType = 'PICKUP'">
          <action-icons icon="store" class="mx-auto mb-2 w-12 h-12" />
          <p>Retiro en tienda</p>
        </div>
      </div>

      <input type="hidden" name="delivery_type" v-model="dispatchType">

    </div>
    <div v-if="dispatchType == 'SHIPPING'">
      <div class="mt-4 mb-2">
        <button class="bt clear text-sm" type="button" v-if="showSameAddresButton" @click="copyBillingAddress">Usar misma dirección de facturación</button>
        </div>
      <slot name="shipping" />
    </div>
    <div v-if="dispatchType == 'PICKUP'">
      <slot name="pickup" />
    </div>
  </div>
</template>
<script>
import { globalEventBus } from '../../_globalEventBus';
export default {
  name: 'checkout-dispatch',
  data() {
    return {
      dispatchType: 'SHIPPING',
      showSameAddresButton: false,
    }
  },
  watch: {
    dispatchType(newVal) {
      globalEventBus.$emit('dispatchTypeUpdated', this.dispatchType);
    }
  },
  methods: {
    copyBillingAddress() {
      globalEventBus.$emit('copyBillingAddress');
    }
  },
  mounted() {
    globalEventBus.$on('countryUpdated', data => {
      if (data.field_name == 'billing_country_id') {
        this.showSameAddresButton = false;
        if (data.value == 90) {
          this.showSameAddresButton = true;
        }
      }
    });
  }
}
</script>